var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("file_details"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "info-box" }, [
        _c("div", { staticClass: "info-box-img" }, [
          _c("img", {
            attrs: {
              src:
                _vm.item.thumbnail ||
                require(`@/assets/imgs/cloudSpace/default-image.webp`),
              alt: "",
            },
          }),
        ]),
        _c("div", { staticClass: "info-box-text" }, [
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("name"))),
              ]),
              _c(
                "div",
                { staticClass: "text" },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editInput,
                          expression: "editInput",
                        },
                      ],
                      attrs: { title: _vm.item.fileNameStr },
                    },
                    [_vm._v(_vm._s(_vm.item.fileNameStr))]
                  ),
                  _c(
                    "el-input",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editInput,
                          expression: "!editInput",
                        },
                      ],
                      attrs: { type: "text", maxlength: "30" },
                      on: { blur: _vm.nameSumbit },
                      nativeOn: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.nameSumbit.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.str,
                        callback: function ($$v) {
                          _vm.str = $$v
                        },
                        expression: "str",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.item.fileNameStr) + " ")]
                  ),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editInput,
                        expression: "editInput",
                      },
                    ],
                    attrs: {
                      src: require("@/assets/imgs/materialsEdit.png"),
                      alt: "",
                    },
                    on: { click: _vm.editText },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("type"))),
              ]),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.item.file_extension)),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("size"))),
              ]),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.item.sizeStr)),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("upload_date"))),
              ]),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.item.timeStr)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "edit" }, [
            _c("div", { staticClass: "state-icon" }, [
              _vm.item.fileStateStr == "default"
                ? _c(
                    "button",
                    {
                      staticClass: "file-edit pointer",
                      on: { click: _vm.fileDownload },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/imgs/cloudSpace/Download.webp"),
                          alt: "",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("download")))]),
                    ]
                  )
                : _vm.item.fileStateStr == "download"
                ? _c(
                    "div",
                    { staticClass: "downloading" },
                    [
                      _c("el-progress", {
                        attrs: {
                          percentage: Number(_vm.item.downloadPercent) || 0,
                          "show-text": false,
                        },
                      }),
                      _c("span", { staticClass: "downloading-text" }, [
                        _vm._v(
                          _vm._s(
                            `${_vm.$t("downloading_text")}（${
                              _vm.item.downloadPercent || 0
                            }%）`
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _c("div", { staticClass: "downloadEnd" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/cloudSpace/notification_slicing_complete.webp"),
                        alt: "",
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("downloaded")))]),
                  ]),
            ]),
            _c(
              "button",
              {
                staticClass: "file-edit",
                class: [
                  _vm.item.fileStateStr == "import" && "pointer",
                  _vm.item.fileStateStr != "import" && "opacity",
                ],
                attrs: { disabled: _vm.item.fileStateStr != "import" },
                on: { click: _vm.importModel },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/imgs/cloudSpace/Import_hover.webp"),
                    alt: "",
                  },
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("import")))]),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "file-edit delete pointer",
                on: {
                  click: _vm.del,
                  mouseleave: _vm.leave,
                  mouseover: _vm.over,
                },
              },
              [
                _c("img", { attrs: { src: _vm.getDelImg, alt: "" } }),
                _c("span", [_vm._v(_vm._s(_vm.$t("delete")))]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }